import { Modal } from "../ui/components";
import api from "../api";

export const MESSAGES_KEYS_DELETE_MODAL = {
    FOLDER: 'folder',
    ONE_FILE: 'one_file',
    BULK_FILE: 'bulk_file',
}

export class ConfirmDeleteModal extends Modal {
    currentDeleteUrl = null;
    selectedIds = [];
    bulkDeleteUrl = null;

    init() {
        super.init();
        this.bulkDeleteUrl = this.element.dataset.bulkDeleteUrl
        this.bindEvents();
        this.messages = this.dataJson("messages");
    }

    bindEvents() {
        this.confirmBtn?.on("click", async () => {
            if (this.currentDeleteUrl) {
                window.location.href = this.currentDeleteUrl;
            } else if (this.selectedIds.length > 0) {
                await this.handleBulkDelete();
                this.hide();
            }
        });

        this.cancelBtn?.on("click", () => {
            this.hide();
            this.reset();
        });
    }

    async handleBulkDelete() {
        try {
            await api.post(this.bulkDeleteUrl, {
                transcriptionIds: this.selectedIds,
            });
            this.emit("bulkDeleteSuccess", this.selectedIds);
        } catch (error) {
            console.error("Bulk delete error:", error);
            this.emit("bulkDeleteError", error);
        }
    }

    show(text, selectedIds = []) {
        this.selectedIds = selectedIds;
        
        if (this.messages[text]) {
            this.text = this.messages[text];
        } else {
            this.text = text;
        }
        super.show();
    }

    setupForUrlDelete(url, test) {
        this.currentDeleteUrl = url;
        this.show(test);
    }

    reset() {
        this.currentDeleteUrl = null;
        this.selectedIds = [];
    }
}
